// extracted by mini-css-extract-plugin
export var gastronovi = "styles-module--gastronovi--AzxoB";
export var iframe = "styles-module--iframe--ECRN4";
export var info = "styles-module--info--wbM4S";
export var privacyText = "styles-module--privacyText--Vx5Ek";
export var text = "styles-module--text--crbj+";
export var textContainer = "styles-module--textContainer--qSG75";
export var textWrapper = "styles-module--textWrapper--udoTO";